import { Component } from '@angular/core';
import type { SectionTitleSettings, SectionTitleTranslationKeys } from '../../../interfaces/Widget.interface';
import { WidgetSize } from '../../../providers/widgets.contants';
import { AbstractWidgetClass } from '../AbstractWidget.class';

@Component({
    styleUrls: ['./widget-section-title.scss'],
    selector: 'widget-section-title',
    templateUrl: 'widget-section-title.html'
})
export class WidgetSectionTitleComponent extends AbstractWidgetClass<SectionTitleTranslationKeys, SectionTitleSettings> {
    size = WidgetSize.FULL;
}
